/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Gallery_Desc_WeclappInputs */



/**
* | output |
* | --- |
* | "Customers, orders and invoices from your ERP." |
*
* @param {Spaces_Gallery_Desc_WeclappInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_gallery_desc_weclapp = /** @type {((inputs?: Spaces_Gallery_Desc_WeclappInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Gallery_Desc_WeclappInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kunden, Aufträge und Rechnungen aus deinem ERP.")
	return /** @type {LocalizedString} */ ("Customers, orders and invoices from your ERP.")
});